import { ModalsReducer } from './modals'

const customReducers = {
  modals: ModalsReducer
}

export default customReducers
